const firebaseConfig = {
    apiKey: "AIzaSyDp3WTZDZPwPlDFdJWobEiF1ZKWzLdUyek",
    authDomain: "tourx-bd.firebaseapp.com",
    projectId: "tourx-bd",
    storageBucket: "tourx-bd.appspot.com",
    messagingSenderId: "942472706462",
    appId: "1:942472706462:web:4208973c0eb90d82c77e8f"
  };

  export default firebaseConfig;